import React, { useEffect, useState } from 'react'
import { Card, Flex, Spin } from 'antd'
import { get } from '../../Common/api'
import dayjs from 'dayjs'
import { t } from 'i18next'

export default function AppointmentDurationStatistics () {
  const [appointments, setAppointments] = useState()
  const [slotAppointments, setSlotAppointments] = useState()
  const [loading, setLoading] = useState()

  const getData = async () => {
    setLoading(true)
    await get({
      url: 'admin/statistics/appointment_durations',
      params: {},
      onSuccess: (json) => {
        setAppointments(json.appointments)
        setSlotAppointments(json.slot_appointments)
        setLoading(false)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  useEffect(() => {
    getData()
  }, [])

  const globalAverage = (values, title) => {
    const total = values.reduce((partialSum, a) => partialSum + a.duration, 0)
    const result = Math.round(total / values.length)
    const style = {
      color: result <= 30 ? 'green' : result <= 45 ? 'orange' : 'red'
    }
    return <Card style={style} title={title}>
      {`${result} minutes`}
    </Card>
  }

  const weekdayAverage = (appointments) => (
    [1, 2, 3, 4, 5, 6, 0].map((day) => {
      const values = appointments.filter(ap => dayjs(ap.begin_date).day() === day)
      return globalAverage(values, dayjs().day(day).format('dddd'))
    })
  )

  const currentSlotAverage = (values) => (
    globalAverage(values, `Moyenne ${dayjs().startOf('hour').format('dddd H')}h - ${dayjs().startOf('hour').add(1, 'hour').format('H')}h (4 dernières semaines)`)
  )

  return (
    <Spin spinning={loading}>
      { appointments &&
        <Flex vertical gap='1em'>
          <Flex justify='space-around'>
            {globalAverage(appointments, t('Admin.Statistics.AppointmentDurationStatistics.globalAverage'))}
            {weekdayAverage(appointments)}
          </Flex>
          <Flex justify='center'>
            {currentSlotAverage(slotAppointments)}
          </Flex>
        </Flex>
      }
    </Spin>
  )
}
